/**
 * מיפוי עמלות ל-persist של הזמנת LDS: commission בעמודה = Agent בלבד; HR לא נשמר כעמלת סוכן.
 * handling_fee תמיד בש״ח אבסולוטיים (גם כשהסוכן בחר %).
 */
import { resolveAbsoluteAgentHandlingFeeIls } from "./resolveAbsoluteAgentHandlingFeeIls.js";

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/** כמו ?? אבל מדלג גם על 0 / ריק — hrCommission=0 לא חוסם unifiedHrMargin. */
function firstPositive(...candidates) {
  for (const v of candidates) {
    if (v == null || v === "") continue;
    const n = Number(v);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return 0;
}

/**
 * @param {object|null|undefined} ourPrice
 * @returns {{ commission: number, handling_fee: number }}
 */
export function buildLdsOrderPersistCommissionFields(ourPrice) {
  if (!ourPrice || typeof ourPrice !== "object") {
    return { commission: 0, handling_fee: 0 };
  }
  const tf =
    ourPrice.ourTotalFare && typeof ourPrice.ourTotalFare === "object"
      ? ourPrice.ourTotalFare
      : null;
  const agent = num(tf?.agentCommission ?? ourPrice.agentCommission);
  const hr = firstPositive(
    tf?.hrCommission,
    tf?.unifiedHrMargin,
    ourPrice.hrCommission,
    ourPrice.unifiedHrMargin
  );
  const handling_fee = resolveAbsoluteAgentHandlingFeeIls(ourPrice);

  if (hr > 0 && agent > 0 && Math.abs(agent - hr) < 0.02) {
    console.warn(
      "[lds-persist] agentCommission ~= hrCommission on ourPrice — check pricing path",
      { agent, hr }
    );
  }

  return { commission: agent, handling_fee };
}
